import { render, staticRenderFns } from "./TwilioVideoCall.vue?vue&type=template&id=2a80609a&scoped=true"
import script from "./TwilioVideoCall.vue?vue&type=script&lang=js"
export * from "./TwilioVideoCall.vue?vue&type=script&lang=js"
import style0 from "./TwilioVideoCall.vue?vue&type=style&index=0&id=2a80609a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80609a",
  null
  
)

export default component.exports